import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { Button } from 'reactstrap';
import { TERMS } from '../../legal/terms';
import { acceptTerms } from '../../api/terms';

// Blocking Terms and Conditions modal shown after login until accepted.
// Language (BS/EN) can be switched right here.
export default class TermsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: window.$locale === 'en' ? 'en' : 'bs',
            checked: false,
            submitting: false,
            error: '',
        };
    }

    accept = () => {
        const { locale, checked, submitting } = this.state;
        if (!checked || submitting) return;
        this.setState({ submitting: true, error: '' });
        acceptTerms(locale)
            .then(() => this.props.onAccepted())
            .catch(() => this.setState({
                submitting: false,
                error: locale === 'en' ? 'Something went wrong. Please try again.' : 'Došlo je do greške. Pokušajte ponovo.',
            }));
    };

    render() {
        const { open, onDecline } = this.props;
        const { locale, checked, submitting, error } = this.state;
        const c = TERMS[locale] || TERMS.bs;

        return (
            <Modal
                open={open}
                onClose={() => {}}
                center
                closeOnOverlayClick={false}
                closeOnEsc={false}
                showCloseIcon={false}
                styles={{ modal: { maxWidth: '720px', width: '92%', borderRadius: '8px', padding: 0 } }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #eee' }}>
                        <h4 style={{ margin: 0, color: '#2c3e50' }}>{c.title}</h4>
                        <div>
                            <Button size="sm" color="primary" outline={locale !== 'bs'} onClick={() => this.setState({ locale: 'bs' })} style={{ marginRight: '4px' }}>BS</Button>
                            <Button size="sm" color="primary" outline={locale !== 'en'} onClick={() => this.setState({ locale: 'en' })}>EN</Button>
                        </div>
                    </div>

                    <div style={{ padding: '16px 20px', overflowY: 'auto' }}>
                        <div style={{ color: '#7f8c8d', marginBottom: '8px' }}>{c.version}</div>
                        <p>{c.intro}</p>
                        {c.sections.map((s, i) => (
                            <div key={i} style={{ marginBottom: '12px' }}>
                                <strong style={{ color: '#2c3e50' }}>{s.h}</strong>
                                <div style={{ color: '#34495e', marginTop: '2px' }}>{s.p}</div>
                            </div>
                        ))}
                    </div>

                    <div style={{ padding: '14px 20px', borderTop: '1px solid #eee' }}>
                        {error ? <div style={{ color: '#c0392b', marginBottom: '8px' }}>{error}</div> : null}
                        <label style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', cursor: 'pointer' }}>
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => this.setState((st) => ({ checked: !st.checked }))}
                                style={{ marginRight: '8px' }}
                            />
                            <span>{c.acceptLabel}</span>
                        </label>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {onDecline && (
                                <Button color="secondary" outline onClick={onDecline} disabled={submitting} style={{ marginRight: '8px' }}>
                                    {c.declineBtn}
                                </Button>
                            )}
                            <Button color="primary" onClick={this.accept} disabled={!checked || submitting}>
                                {submitting ? '...' : c.acceptBtn}
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TermsGate/TermsModal.js